export default {
  namespaced: true,

  state: () => ({
    cartProducts: {
      data: [],
      links: {},
      meta: {},
    },
    isLoading: false,
    isShowEditVariant: false,
  }),

  getters: {
  },

  mutations: {
    SET_CART_PRODUCTS(state, payload) {
      state.cartProducts = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
    SET_OPEN_EDIT(state, value) {
      state.isShowEditVariant = value
    },
  },

  actions: {
    async getCartProducts({ commit, dispatch }, { page = null } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/carts/no-variant'

        const response = await this._vm.$http.get(url, { params: { page } })

        if (response.data.meta.current_page > response.data.meta.last_page && response.data.meta.total > 0) {
          dispatch('getCartProducts', { page: response.data.meta.last_page })
          return null
        }

        commit('SET_CART_PRODUCTS', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        commit('SET_LOADING', false)
        return error
      }
    },
    async updateVariant({ commit, dispatch, state }, { skuId, alternativeSkuId, query }) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/carts/${skuId}`

        const response = await this._vm.$http.put(url, { sku_id: alternativeSkuId })
        commit('SET_LOADING', false)

        dispatch('getCartProducts', { page: state.cartProducts.meta.current_page, keyword: query.keyword || '' })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah URL Produk!',
        }, { root: true })

        commit('SET_OPEN_EDIT', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING', false)
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
  },
}
